export default __webpack_public_path__ + "assets/ico_rules-1061b218.svg";